<template >

  <el-cascader class="csz"

      v-model="areaCode"
      :options="areas"
      ref="areaSelect"
      clearable
      :placeholder="placeholder"
      :filterable="true"
      :show-all-levels="true"
      @change="handleItemChange"
      :props="props"
  >

  </el-cascader>

</template>

<script>
import BasicModel from '@/framework/basic/BasicModel'
export default {
  name: 'city-cascader',
  data: function () {
    return {
      areaCode: [],
      areas: [],
      props: {
        checkStrictly: true,
        multiple: true,
        emitPath: false,
        label: 'name',
        value: 'name',
        children: 'districts'
      }

    }
  },
  props: {

    placeholder: {
      type: String,
      default: function () {
        return '请选择'
      }
    }

  },

  watch: {

  },

  created: function () {
    this.initData('')
  },
  methods: {
    setValue: function (val) {
      let that = this

      if (val) {
        that.areaCode = val.split(',')
      }
    },

    handleItemChange: function (newValue) {
      let areaSelect = this.$refs['areaSelect']

      // 获取选中的节点
      let rtData = []
      let checkedNodes = areaSelect.getCheckedNodes()
      for (let i = 0; i < checkedNodes.length; i++) {
        rtData.push(checkedNodes[i].label)
      }
      this.$emit('onAreaChanged', rtData)
    },

    initData: function (keyword) {
      let that = this

      BasicModel.post(that, '/channel/getAdministrativeAreaOfGaode.action', { keyword: keyword, subdistrict: 3 }, {
        success: function (dataInfo) {
          that.areas = dataInfo.datas[0].districts
        }
      })
    }
  }
}
</script>
<style >

</style>
